import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { authContext } from '../../../contexts/AuthContext'
import './SignIn.css'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import BlockUi from 'react-block-ui'
import 'react-block-ui/style.css'
import { verifyTOTP } from '../../../Utils/MFA'
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions'
import { apiUrl } from '../../../config/api'
import { jwtDecode } from 'jwt-decode'

const SignIn = (props) => {
  // Pagina de login para clientes (usuarios externos)

  const [snackbarErrorOpen, setSnackbarErrorOpen] = React.useState(false)
  const [snackbarTokenErrorOpen, setSnackbarTokenErrorOpen] =
    React.useState(false)
  const [snackbarSuccessOpen, setSnackbarSuccessOpen] = React.useState(false)
  const [showToken, setShowToken] = React.useState(false)
  const [blockingLogin, setBlockingLogin] = React.useState(false)
  const { setAuthData } = useContext(authContext)
  const { t } = useTranslation()
  const [currentUser, setCurrentUser] = React.useState()
  const [currentData, setCurrentData] = React.useState()
  const [currentToken, setCurrentToken] = React.useState()
  const [termsUser, setTermsUser] = React.useState()

  const handleSnackbarClose = () => {
    setSnackbarErrorOpen(false)
    setSnackbarSuccessOpen(false)
  }

  const onLoginFormSubmit = (e) => {
    e.preventDefault()
    setBlockingLogin(true)

    let creds = {}
    creds.email = document.getElementById('login_email').value
    creds.password = document.getElementById('login_password').value
    creds.brandLabel = window.$brand

    let url = apiUrl('CredentialsLogin')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(creds)
    })
      .then((res) => {
        if (res.status === 401) {
          setSnackbarErrorOpen(true)
        } else if (res.status === 200) {
          let data = res.json()
          data.then((token) => {
            const decoded = jwtDecode(token)

            let user = {
              id: decoded.id,
              first_name: decoded.first_name,
              last_name: decoded.last_name,
              userType: decoded.user_type,
              email: decoded.email,
              image_url: decoded.image_url,
              phone: decoded.phone,
              mobile: decoded.mobile,
              mfaEnabled: decoded.mfa_enabled,
              mfaSecret: decoded.mfa_secret,
              acceptedTerms: decoded.accepted_terms
            }

            setCurrentUser(user)
            setCurrentData(data)
            setCurrentToken(token)
            if (user.mfaEnabled === '0') {
              if (_.isEmpty(user.acceptedTerms)) {
                setTermsUser({ acceptedTerms: true })
              } else {
                setAuthData('client', user, data, token)
                if (user.userType === 'external_admin') {
                  props.history.push('/Clientes')
                } else if (user.userType === 'admin_zapotal') {
                  props.history.push('/Condominios')
                } else {
                  props.history.push('/MisDocumentos')
                }
                setSnackbarSuccessOpen(true)
              }
              // setEnableMFAUser(user);
            } else if (user.mfaEnabled === '1') {
              setShowToken(true)
              document.getElementById('login_token').focus()
            }
          })
        }
        setBlockingLogin(false)
      })
      .catch((error) => {
        console.log(error)
        setBlockingLogin(false)
      })
  }

  const onLoginTokenSubmit = () => {
    let token = document.getElementById('login_token').value
    let result = verifyTOTP(token, currentUser.mfaSecret)
    if (result) {
      if (_.isEmpty(currentUser.acceptedTerms)) {
        setTermsUser({ acceptedTerms: true })
      } else {
        setAuthData('client', currentUser, currentData, currentToken)
        props.history.push('/MisDocumentos')
        setSnackbarSuccessOpen(true)
      }
    } else {
      setSnackbarTokenErrorOpen(true)
    }
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      if (!showToken) {
        onLoginFormSubmit(e)
      } else {
        onLoginTokenSubmit()
      }
    }
  }

  const handleDialogClose = () => {
    setTermsUser({})
    // setEnableMFAUser({});
  }

  const acceptTermsAndConditions = () => {
    let params = { userId: currentUser.id }
    let url = apiUrl('AcceptTermsAndConditions')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Accepted')

        setAuthData('client', currentUser, currentData, currentToken)

        if (currentUser.userType === 'external_admin') {
          props.history.push('/Clientes')
        } else if (currentUser.userType === 'admin_zapotal') {
          props.history.push('/Condominios')
        } else {
          props.history.push('/MisDocumentos')
        }
        setSnackbarSuccessOpen(true)
      })
      .catch((error) => console.log(error))
  }

  return (
    <Box className='login-box'>
      <div
        className='login-wrap'
        style={{
          backgroundImage: `url(${
            window.$brand === 'PRB' || window.$brand === 'STRATOS'
              ? '/assets/bg_PRB.png'
              : '/assets/bg_BLP.png'
          })`
        }}
      >
        <BlockUi tag='div' blocking={blockingLogin}>
          <form className='login-form' action=''>
            <div className='login-form-header'>
              <Box
                component='img'
                alignItems='center'
                sx={{
                  height: window.$brand === 'PRB' ? 80 : 60
                }}
                alt='Logo'
                src={
                  window.$brand === 'PRB' ||
                  window.$brand === 'SUBWAY' ||
                  window.$brand === 'KRAFT'
                    ? '/assets/legally.png'
                    : window.$brand === 'STRATOS'
                    ? '/assets/stratos.png'
                    : '/assets/BLP Micrositeazulverde.png'
                }
              />
              {window.$brand === 'BLP' && <h3>{t('Client_Portal')}</h3>}
            </div>
            <div className='login-form-group'>
              <TextField
                disabled={showToken}
                required
                id='login_email'
                label={t('Email')}
                type='text'
                fullWidth
                variant='standard'
                onKeyDown={handleEnter}
                inputProps={{ maxLength: 50 }}
              />
            </div>
            <div className='login-form-group'>
              <TextField
                disabled={showToken}
                required
                id='login_password'
                label={t('Password')}
                type='password'
                fullWidth
                variant='standard'
                onKeyDown={handleEnter}
                inputProps={{ maxLength: 20 }}
              />
            </div>
            {showToken && (
              <div className='login-form-group'>
                <TextField
                  required
                  id='login_token'
                  label={'Token'}
                  type='text'
                  fullWidth
                  variant='standard'
                  onKeyDown={handleEnter}
                  inputProps={{ maxLength: 6 }}
                />
              </div>
            )}
            <div className='login-form-group'>
              <Button
                onClick={(e) => {
                  if (!showToken) {
                    onLoginFormSubmit(e)
                  } else {
                    onLoginTokenSubmit()
                  }
                }}
                style={{
                  color: `${window.$brand === 'PRB' ? '#cc0033' : '#05539c'}`
                }}
              >
                {t('Login')}
              </Button>
            </div>
            {/* <div className="login-form-footer">
              <SignInButton history={props.history} />
            </div> */}
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              open={snackbarErrorOpen}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              key={'bottomcentererror'}
            >
              <Alert elevation={6} variant='filled' severity='error'>
                {t('Invalid_credentials')}
              </Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              open={snackbarTokenErrorOpen}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              key={'bottomcentererror'}
            >
              <Alert elevation={6} variant='filled' severity='error'>
                {t('Invalid_token')}
              </Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              open={snackbarSuccessOpen}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              key={'bottomcentersuccess'}
            >
              <Alert elevation={6} variant='filled' severity='success'>
                {t('Welcome')}
              </Alert>
            </Snackbar>
          </form>
        </BlockUi>
      </div>
      <TermsAndConditions
        user={termsUser}
        handleDialogClose={handleDialogClose}
        acceptTermsAndConditions={acceptTermsAndConditions}
      />
    </Box>
  )
}

export default SignIn
